module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.query.expanded != true && _vm.$route.query.expanded != 'true'),
      expression: "$route.query.expanded!=true && $route.query.expanded != 'true'"
    }],
    staticClass: "menu-wrapper"
  }, [_c('div', {
    staticClass: "greeting"
  }, [_c('h4', [_vm._v(_vm._s(_vm.greeting)), (!_vm.roles.includes('LiteStudent')) ? _c('img', {
    staticClass: "role-icon",
    attrs: {
      "src": _vm._f("roleIcon")(_vm.roles, _vm.localStorage.terms)
    }
  }) : _vm._e()])]), _vm._v(" "), (!_vm.roles.includes('LiteStudent')) ? _c('clock') : _vm._e(), _vm._v(" "), (_vm.roles.includes('Registrant') || _vm.roles.includes('CampusRegistrant')) ? _c('enrollment-selector') : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMobileMenu),
      expression: "showMobileMenu"
    }],
    staticClass: "menu"
  }, [(_vm.terms) ? _c('ul', {
    staticClass: "sidebar"
  }, [(_vm.localStorage.roles.indexOf('Student') > -1 && _vm.localStorage.terms.toString().split(',').length < 4) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.showCourseMenu = false
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-item nav-link",
    attrs: {
      "to": "/home"
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../assets/img/icons/dashboard.svg"),
      "alt": "Dashboard"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-label"
  }, [_vm._v("Dashboard")])])], 1) : _vm._e(), _vm._v(" "), (_vm.localStorage.roles.includes('Mentor') ||
    (_vm.localStorage.roles.indexOf('Student') > -1 && _vm.localStorage.terms.toString().split(',').length === 4)) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.showCourseMenu = false
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-item nav-link",
    attrs: {
      "to": "/mentor-dashboard"
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../assets/img/icons/dashboard.svg"),
      "alt": "Dashboard"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-label"
  }, [_vm._v("Dashboard")])])], 1) : _vm._e(), _vm._v(" "), (_vm.localStorage.roles.indexOf('OnlineDirector') > -1) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.showCourseMenu = false
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-item nav-link",
    attrs: {
      "to": "/mentor-connection-approval"
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../assets/img/icons/dashboard.svg"),
      "alt": "Dashboard"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-label"
  }, [_vm._v("Mentor Requests")])])], 1) : _vm._e(), _vm._v(" "), (_vm.localStorage.roles.includes('Supervisor')) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.showCourseMenu = false
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-item nav-link",
    attrs: {
      "to": "/feedback"
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../assets/img/icons/feedback.svg"),
      "alt": "Feedback"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-label"
  }, [_vm._v("Feedback")])])], 1) : _vm._e(), _vm._v(" "), (_vm.localStorage.roles.includes('GlobalMentor') || _vm.localStorage.roles.includes('Recruiter')) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.showCourseMenu = false
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-item nav-link",
    attrs: {
      "to": "/meetings"
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../assets/img/icons/dashboard.svg"),
      "alt": "Dashboard"
    }
  }), _vm._v(" "), (_vm.localStorage.roles.includes('GlobalMentor')) ? _c('span', {
    staticClass: "menu-label"
  }, [_vm._v("Global Mentor")]) : _c('span', {
    staticClass: "menu-label"
  }, [_vm._v("Meetings")])])], 1) : _vm._e(), _vm._v(" "), (_vm.localStorage.roles.indexOf('CampusStudent') > -1 && _vm.localStorage.terms.toString().split(',').length === 4) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.showCourseMenu = false
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-item nav-link",
    attrs: {
      "to": "/mentor-dashboard"
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../assets/img/icons/dashboard.svg"),
      "alt": "Dashboard"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-label"
  }, [_vm._v("Mentorship")])])], 1) : _vm._e(), _vm._v(" "), (_vm.localStorage.roles.includes('OnlineReelReviewer')) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.showCourseMenu = false
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-item nav-link",
    attrs: {
      "to": "/reel-review"
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../assets/img/icons/dashboard.svg"),
      "alt": "Dashboard"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-label"
  }, [_vm._v("Reel Review")])])], 1) : _vm._e(), _vm._v(" "), (_vm.localStorage.roles.includes('CampusStudent') ||
    _vm.localStorage.roles.includes('CampusInstructor') ||
    _vm.localStorage.hasLibraryAccess == true) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.showCourseMenu = false
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-item nav-link",
    attrs: {
      "to": "/campus-dashboard"
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../assets/img/icons/dashboard.svg"),
      "alt": "Dashboard"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-label"
  }, [_vm._v("Video Library")])])], 1) : _vm._e(), _vm._v(" "), ((_vm.currentTerm && new Date(_vm.currentTerm.startDate) <= new Date()) && _vm.localStorage.roles.indexOf('Student') > -1) ? _c('li', {
    staticClass: "course-menu-link"
  }, [_c('a', {
    staticClass: "nav-item nav-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showCourseMenu = !_vm.showCourseMenu
      }
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../assets/img/icons/courses.svg"),
      "alt": "Courses"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-label"
  }, [_vm._v("Courses")])]), _vm._v(" "), (_vm.showCourseMenu) ? _c('div', {
    staticClass: "course-menu",
    on: {
      "mouseleave": function($event) {
        _vm.showCourseMenu = false
      }
    }
  }, [_c('ul', _vm._l((_vm.courses), function(course) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": {
          name: 'course',
          params: {
            termId: course.term,
            courseId: course.associated.courseId,
            instanceId: course.id
          }
        }
      }
    }, [_c('img', {
      attrs: {
        "src": course.associated.image
      }
    }), _vm._v(" "), _c('h6', [_vm._v(_vm._s(course.associated.name))])])], 1)
  }))]) : _vm._e()]) : _vm._e(), _vm._v(" "), ((_vm.currentTerm && new Date(_vm.currentTerm.startDate) <= new Date())) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.showCourseMenu = false
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-item nav-link",
    attrs: {
      "to": "/resources"
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../assets/img/icons/resources.svg"),
      "alt": "Resources"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-label"
  }, [_vm._v("Course Resources")])])], 1) : _vm._e(), _vm._v(" "), (_vm.localStorage.roles.indexOf('Student') > -1 && _vm.localStorage.terms.toString().split(',').length < 4 && (_vm.currentTerm && new Date(_vm.currentTerm.startDate) <= new Date())) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.showCourseMenu = false
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-item nav-link",
    attrs: {
      "to": "/assignments"
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../assets/img/icons/homework.svg"),
      "alt": "Assignments"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-label"
  }, [_vm._v("Assignments")])])], 1) : _vm._e(), _vm._v(" "), (
    (_vm.localStorage.roles.includes('Student') ||
      _vm.localStorage.roles.includes('CampusStudent') ||
      _vm.localStorage.roles.includes('Supervisor')
    ) &&
    !_vm.localStorage.roles.includes('LiteStudent')
  ) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.showCourseMenu = false
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-item nav-link",
    attrs: {
      "to": "/calendar"
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../assets/img/icons/calendar.svg"),
      "alt": "Calendar"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-label"
  }, [_vm._v("Calendar")])])], 1) : _vm._e(), _vm._v(" "), (_vm.localStorage.roles.includes('TA')) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.showCourseMenu = false
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-item nav-link",
    attrs: {
      "to": "/ta-sessions"
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../assets/img/icons/calendar.svg"),
      "alt": "Calendar"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-label"
  }, [_vm._v("TA Sessions")])])], 1) : _vm._e(), _vm._v(" "), (!_vm.roles.includes('LiteStudent')) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.showCourseMenu = false
      }
    }
  }, [(_vm.localStorage.roles.includes('Recruiter')) ? _c('router-link', {
    staticClass: "nav-item nav-link",
    attrs: {
      "to": "/forum/categories/job-board"
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../assets/img/icons/forum.svg"),
      "alt": "Forum"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-label"
  }, [_vm._v("Job Board")])]) : _c('router-link', {
    staticClass: "nav-item nav-link",
    attrs: {
      "to": "/forum"
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../assets/img/icons/forum.svg"),
      "alt": "Forum"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-label"
  }, [_vm._v("Forum")])])], 1) : _vm._e(), _vm._v(" "), (!_vm.roles.includes('LiteStudent')) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.showCourseMenu = false
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-item nav-link",
    attrs: {
      "to": "/galleries"
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../assets/img/icons/galleries.svg"),
      "alt": "Galleries"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-label"
  }, [_vm._v("Galleries")])])], 1) : _vm._e(), _vm._v(" "), (_vm.isNotRecruiter) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.showCourseMenu = false
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-item nav-link",
    attrs: {
      "to": "/kb"
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../assets/img/icons/resources.svg"),
      "alt": "Resources"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-label"
  }, [_vm._v("Knowledge Base")])])], 1) : _vm._e(), _vm._v(" "), ((_vm.localStorage.roles.indexOf('Student') > -1 && _vm.localStorage.transitioned != 'true') ||
    _vm.localStorage.roles.includes('Supervisor') ||
    _vm.localStorage.roles.includes('Mentor') ||
    _vm.localStorage.roles.includes('CampusMentor') ||
    _vm.localStorage.roles.includes('CampusInstructor') ||
    _vm.localStorage.roles.includes('Recruiter') ||
    _vm.localStorage.roles.includes('Admin') ||
    _vm.localStorage.roles.includes('Faculty')) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.showCourseMenu = false
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-item nav-link",
    attrs: {
      "to": "/help"
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../assets/img/icons/help.svg"),
      "alt": "Help"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-label"
  }, [_vm._v("Help & Support")])])], 1) : _vm._e(), _vm._v(" "), ((_vm.localStorage.roles.includes('Student') ||
      _vm.localStorage.roles.includes('CampusStudent')) &&
    _vm.localStorage.terms.toString().split(',').length === 4) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.showCourseMenu = false
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-item nav-link",
    attrs: {
      "to": "/final-project"
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../assets/img/icons/final-project.svg"),
      "alt": "Final Project"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-label"
  }, [_vm._v("Submit Demo Reel")])])], 1) : _vm._e(), _vm._v(" "), ((_vm.localStorage.roles.includes('CampusStudent') || _vm.localStorage.transitioned == 'true') && !_vm.roles.includes('LiteStudent')) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.showCourseMenu = false
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-item nav-link",
    attrs: {
      "to": "/kb-article/29"
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../assets/img/icons/help.svg"),
      "alt": "Help"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-label"
  }, [_vm._v("Campus Support")])])], 1) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.globalCheckins && _vm.globalCheckins.length > 0) ? _c('global-checkin', {
    attrs: {
      "alert": _vm.globalCheckins[0]
    },
    on: {
      "reload": function($event) {
        _vm.getGlobalCheckins()
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cb98c1bc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar.vue
// module id = 2130
// module chunks = 2